export default function fileName(){
    if(document.querySelector(".contact__file #curriculum")){
        let inputFile = document.querySelector(".contact__file #curriculum");
        let fileName = document.querySelector(".contact__file span.file");

        inputFile.addEventListener("change", (event) => {
            let uploadName = event.target.files[0].name;

            fileName.textContent = uploadName;
        });
    }  
}